import { Refresh2 } from "iconsax-reactjs";
import { BodyText, Card, CardContent, HeadingText } from "../../../shared/ui";
import { KybRequirement } from "../types";
import {
  ActionIconButton,
  ChecklistDecisionButton,
  ChecklistItem,
  FlagTargetKind,
} from "./kybShowReviewShared";

type KybComplianceChecklistCardProps = {
  checklistItems: ChecklistItem[];
  reviewingStatus: "APPROVED" | "REJECTED" | null;
  isReadOnly?: boolean;
  onOpenFlagModal: (
    requirement: KybRequirement | null | undefined,
    kind: FlagTargetKind,
    person?: ChecklistItem["person"],
  ) => void;
  onReviewRequirement: (
    requirement: KybRequirement,
    status: "APPROVED" | "REJECTED",
    comment: string,
    kind: FlagTargetKind,
    person?: ChecklistItem["person"],
  ) => void;
  onOpenReEnterModal: (requirement: KybRequirement, person?: ChecklistItem["person"]) => void;
};

const KybComplianceChecklistCard = ({
  checklistItems,
  reviewingStatus,
  isReadOnly = false,
  onOpenFlagModal,
  onReviewRequirement,
  onOpenReEnterModal,
}: KybComplianceChecklistCardProps) => {
  return (
    <Card className="overflow-hidden rounded-[20px] border border-[#E1E6FF] shadow-none">
      <CardContent className="p-6">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <HeadingText className="aku-heading-h5-medium text-[#161827]">
            Do the records match the provided documents?
          </HeadingText>
        </div>

        <div className="mt-7 space-y-7">
          {checklistItems.map((item) => {
            const isInformation = item.requirement.type === "field";
            const isFlagged = Boolean(item.flagged);
            const isApproved = Boolean(item.approved);

            return (
              <div key={item.id}>
                <BodyText className="aku-body-small-regular text-[#6F739B]">
                  {item.label}
                </BodyText>
                <div className="mt-1 flex items-center justify-between gap-4">
                  <div className="min-w-0 aku-body-small-regular text-[#161827]">
                    {item.value}
                  </div>
                  {!isReadOnly ? (
                    <div className="flex shrink-0 items-center gap-2">
                      {isFlagged && isInformation ? (
                        <ActionIconButton
                          title="Re-enter information"
                          disabled={reviewingStatus !== null}
                          onClick={() => onOpenReEnterModal(item.requirement, item.person)}
                        >
                          <Refresh2 size={19} />
                        </ActionIconButton>
                      ) : null}
                      <ChecklistDecisionButton
                        tone="no"
                        active={isFlagged}
                        disabled={isFlagged || reviewingStatus !== null}
                        onClick={() =>
                          onOpenFlagModal(
                            item.requirement,
                            item.requirement.type === "document"
                              ? "document"
                              : "information",
                            item.person,
                          )
                        }
                      >
                        No
                      </ChecklistDecisionButton>
                      <ChecklistDecisionButton
                        tone="yes"
                        active={isApproved}
                        disabled={isApproved || reviewingStatus !== null}
                        onClick={() =>
                          onReviewRequirement(
                            item.requirement,
                            "APPROVED",
                            "Approved",
                            item.requirement.type === "document"
                              ? "document"
                              : "information",
                            item.person,
                          )
                        }
                      >
                        Yes
                      </ChecklistDecisionButton>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default KybComplianceChecklistCard;
